import { GET} from "./api.service.wrapper";
import {apiUrl} from "../utils/constants";

export const GetDashboardData = async (keyword = '', is_paginate = 1) => {
    let params = {};
    const response = await GET(apiUrl.dashboard, params);
    return response;
}

